import React, { useEffect, useState } from "react";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import DropDownTax from "../../../../styled-components/dropdown/dropdownTax";
import * as Style from "./styles/tax-information";
import { InputGroup } from "../../../../styled-components/input/styles/input";
import IconInputTax from "../../../../styled-components/input/icon-input-tax";
import { Button } from "../../../../styled-components/button";
import { Text } from "../../../../styled-components/text";
import TaxCredits from "../tax-credits/tax-credits";
import {
  deductionsList,
  taxFillingElectionList,
  statesList,
  citiesByState,
} from "../data/data";
import { MODULE_API } from "../../../../../apis";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
import { SocialSecurityHardCodeFields } from "../../../../../newComponents/SocialSecurity/components/SocialSecurityHardCodeFields";
import {
  calculateCapitalGainsTax,
  calculateProjectionSeries,
  calculateTotalTax,
} from "../../../../../helpers/taxCalculations";
import {
  InputNumber,
  DatePicker,
  Radio,
  Checkbox,
  Select,
  Input,
  Collapse,
} from "antd";
import moment from "moment";
import { TaxProjectionOverview } from "./TaxProjectionOverview";
import TAX_AND_INFLATION_API from "../../../../../apis/tax_and_inflation.api";
import NewLoader from "../../../../styled-components/loader/NewLoader";
const { Panel } = Collapse;
function TaxInformation({ handleTaxInflationObject, nextForm, data, taxInfo }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [yearlyDataReport, setYearlyDataReport] = useState(null);
  const [taxInformationData, setTaxInformationData] = useState(null);
  const [creditData, setCreditData] = useState([]);
  const [carryForwardCredits, setCarryForwardCredits] = useState([]);

  const getTaxInflationDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxInflationDetails();
      if (data && data.data) {
        //inflation details
        // console.log("response==>", data.data);
        const taxInfoData = data.data[0];
        if (taxInfoData) {
          setTaxInformationData({
            "State Taxation":
              taxInfoData && taxInfoData.state ? taxInfoData.state : "",
            "City of Residence":
              taxInfoData && taxInfoData.city ? taxInfoData.city : "",
            "Tax Filling Election":
              taxInfoData && taxInfoData.taxFillingElection
                ? taxInfoData.taxFillingElection
                : "",
            Deductions:
              taxInfoData && taxInfoData.deductions
                ? taxInfoData.deductions
                : "",
            "State Tax Effective Rate":
              taxInfoData && taxInfoData.stateTaxRate
                ? taxInfoData.stateTaxRate
                : "",
            "Federal Tax Rate":
              taxInfoData && taxInfoData.federalTaxRate
                ? taxInfoData.federalTaxRate
                : "",
            "Total Tax Rate":
              taxInfoData && taxInfoData.totalTaxRate
                ? taxInfoData.totalTaxRate
                : "",
            "Federal Collectible Tax Rate":
              taxInfoData && taxInfoData.federalCollectibleTaxRate
                ? taxInfoData.federalCollectibleTaxRate
                : "",
            "Medical and Dental Expenses":
              taxInfoData && taxInfoData.medicalAndDentalExpenses
                ? taxInfoData.medicalAndDentalExpenses
                : "",
            "State and Local Taxes (SALT)":
              taxInfoData && taxInfoData.stateAndLocalTaxesSalt
                ? taxInfoData.stateAndLocalTaxesSalt
                : "",
            "Home Mortgage Interest":
              taxInfoData && taxInfoData.homeMortgageInterest
                ? taxInfoData.homeMortgageInterest
                : "",
            "Charitable Contributions":
              taxInfoData && taxInfoData.charitableContributions
                ? taxInfoData.charitableContributions
                : "",
            "Number of Dependents":taxInfoData && taxInfoData.noOfDependents
                ? taxInfoData.noOfDependents
                : "",
            ...taxInfoData,
          });
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Tax Inflation Details", error);
    }
  };
  const getTaxCredit = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxCreditList();
      if (data && data.data) {
        setCreditData(data.data.rows);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  const getCarryForward = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchCarryForward();
      if (data && data.data) {
        setCarryForwardCredits(data.data.rows);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };

  const handleInputChangeTax = (name, value) => {
    setYearlyDataReport({
      ...yearlyDataReport,
      [name]: value,
    });
  };

  const getIncomeTotalYearly = async () => {
    try {
      setLoading(true);
      const currentDate = moment();
      const startDate = currentDate
        .clone()
        .startOf("year")
        .format("YYYY-MM-DD");
      // const endDate = currentDate.clone().endOf("year").format("YYYY-MM-DD");
      const endDate = currentDate.clone().endOf("month").format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchIncomeSum(startDate, endDate);
      if (datares && datares.data) {
        const yearlyData = datares.data;
        let yearlyResponse = {
          ...datares.data,
          totalYearly: yearlyData
            ? (+yearlyData.Active || 0) + (+yearlyData.Passive || 0)
            : 0,
        };
        setYearlyDataReport(yearlyResponse);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const { styles } = defaultStyles;

  const handleTaxInformationChange = (name, value) => {
    setTaxInformationData({
      ...taxInformationData,
      [name]: value,
    });
  };

  const handleTaxInformation = (obj) => {
    // console.log("obj", obj);
    const { name, value } = obj;

    setTaxInformationData({
      ...taxInformationData,
      [name]: value,
    });
  };

  const nextComponent = {
    name: "taxCredits",
    title: "Tax Credits",
    unique: "Other Tax Credit",
    isMulti: true,
    component: TaxCredits,
    taxCredits: {},
  };

  const handleSaveTaxInformation = async () => {
    try {
      setLoading(true);

      let payload = {
        state:
          taxInformationData && taxInformationData["State Taxation"]
            ? taxInformationData["State Taxation"]
            : "",
        city:
          taxInformationData && taxInformationData["City of Residence"]
            ? taxInformationData["City of Residence"]
            : "",
        taxFillingElection:
          taxInformationData && taxInformationData["Tax Filling Election"]
            ? taxInformationData["Tax Filling Election"]
            : "",
        deductions:
          taxInformationData && taxInformationData["Deductions"]
            ? taxInformationData["Deductions"]
            : "",
        stateTaxRate:
          taxInformationData && taxInformationData["State Tax Effective Rate"]
            ? Number(taxInformationData["State Tax Effective Rate"])
            : 0,
        federalTaxRate:
          taxInformationData &&
          taxInformationData.taxInformation &&
          taxInformationData.taxInformation.data &&
          taxInformationData.taxInformation.data[0] &&
          taxInformationData.taxInformation.data[0]["Federal Tax Rate"]
            ? Number(
                taxInformationData.taxInformation.data[0]["Federal Tax Rate"]
              )
            : 0,
        totalTaxRate:
          taxInformationData && taxInformationData["Total Tax Rate"]
            ? Number(taxInformationData["Total Tax Rate"])
            : 0,
        federalCollectibleTaxRate:
          taxInformationData &&
          taxInformationData["Federal Collectible Tax Rate"]
            ? Number(taxInformationData["Federal Collectible Tax Rate"])
            : 0,
        effectiveTaxRate:
          result && result.effectiveRate ? Number(result.effectiveRate) : 0,
        marginalTaxRate:
          result && result.marginalRate ? Number(result.marginalRate) : 0,
        totalTaxLiability:
          result && result.totalTaxLiability
            ? Number(result.totalTaxLiability)
            : 0,
        medicalAndDentalExpenses:
          taxInformationData &&
          taxInformationData["Medical and Dental Expenses"]
            ? Number(taxInformationData["Medical and Dental Expenses"])
            : 0,
        stateAndLocalTaxesSalt:
          taxInformationData &&
          taxInformationData["State and Local Taxes (SALT)"]
            ? Number(taxInformationData["State and Local Taxes (SALT)"])
            : 0,
        homeMortgageInterest:
          taxInformationData && taxInformationData["Home Mortgage Interest"]
            ? Number(taxInformationData["Home Mortgage Interest"])
            : 0,
        charitableContributions:
          taxInformationData && taxInformationData["Charitable Contributions"]
            ? Number(taxInformationData["Charitable Contributions"])
            : 0,
        noOfDependents:
          taxInformationData && taxInformationData["Number of Dependents"]
            ? Number(taxInformationData["Number of Dependents"])
            : 0,
        // --- Income & AGI Adjustments ---
        grossIncome:
          taxInformationData && taxInformationData.grossIncome
            ? Number(taxInformationData.grossIncome)
            : 0,
        earnedIncome:
          taxInformationData && taxInformationData.earnedIncome
            ? Number(taxInformationData.earnedIncome)
            : 0,
        hsaContributions:
          taxInformationData && taxInformationData.hsaContributions
            ? Number(taxInformationData.hsaContributions)
            : 0,
        studentLoan:
          taxInformationData && taxInformationData.studentLoan
            ? Number(taxInformationData.studentLoan)
            : 0,
        iraContribution:
          taxInformationData && taxInformationData.iraContribution
            ? Number(taxInformationData.iraContribution)
            : 0,
        educatorExpenses:
          taxInformationData && taxInformationData.educatorExpenses
            ? Number(taxInformationData.educatorExpenses)
            : 0,

        // --- Capital Gains / Losses ---
        shortTermGainsLoss:
          taxInformationData && taxInformationData.shortTermGainsLoss
            ? Number(taxInformationData.shortTermGainsLoss)
            : 0,
        longTermGainsLoss:
          taxInformationData && taxInformationData.longTermGainsLoss
            ? Number(taxInformationData.longTermGainsLoss)
            : 0,
        lossCarryforward:
          taxInformationData && taxInformationData.lossCarryforward
            ? Number(taxInformationData.lossCarryforward)
            : 0,

        // --- Federal Tax Credits ---
        careExpenses:
          taxInformationData && taxInformationData.careExpenses
            ? Number(taxInformationData.careExpenses)
            : 0,
        educationExpenses:
          taxInformationData && taxInformationData.educationExpenses
            ? Number(taxInformationData.educationExpenses)
            : 0,
        grossIncome:
          (taxInformationData && taxInformationData.earnedIncome) ||
          (taxInformationData && taxInformationData.AGI) ||
          result ? result.grossIncome : 0,

        // ...taxInformationData,
      };

      // If id exists, include it to update, else save new
      if (taxInformationData && taxInformationData.id) {
        payload.id = taxInformationData.id;
        await TAX_AND_INFLATION_API.updateTaxInflationDetails(payload);
      } else {
        await TAX_AND_INFLATION_API.saveTaxInflationDetails(payload);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error while saving/updating tax information:", error);
    }
  };

  const submitData = async () => {
    await handleSaveTaxInformation();
    handleTaxInflationObject(taxInformationData);
    nextForm(nextComponent);
  };

  const cityList =
    taxInformationData &&
    taxInformationData["State Taxation"] &&
    citiesByState[taxInformationData["State Taxation"]]
      ? citiesByState[taxInformationData["State Taxation"]].map((city) => ({
          name: city,
        }))
      : [];

  useEffect(() => {
    getIncomeTotalYearly();
    getTaxInflationDetails();
    getTaxCredit();
    getCarryForward();
  }, []);

  // useEffect(() => {
  //   const grossIncome = yearlyDataReport
  //     ? yearlyDataReport.totalYearly
  //     : (taxInformationData && taxInformationData["Gross Income"]) || 0;

  //   const generalInflationRate =
  //     taxInformationData && taxInformationData.generalInflationRate
  //       ? taxInformationData.generalInflationRate || 0
  //       : 0;

  //   const filingStatus =
  //     (taxInformationData && taxInformationData["Tax Filling Election"]) ||
  //     "single";
  //   const stateName =
  //     (taxInformationData && taxInformationData["State Taxation"]) ||
  //     "California";
  //   const deductions =
  //     (taxInformationData && taxInformationData["Deductions"]) || "Standard";

  //   // Prepare credits object with all required inputs
  //   const credits = {
  //     numChildrenUnder17:
  //       (taxInformationData && taxInformationData.numChildrenUnder17) || 0,
  //     contributionAmount:
  //       (taxInformationData && taxInformationData.retirementContribution) || 0,
  //     agi: (taxInformationData && taxInformationData.AGI) || grossIncome,
  //     magi:
  //       (taxInformationData && taxInformationData.MAGI) ||
  //       (taxInformationData && taxInformationData.AGI) ||
  //       grossIncome,
  //     improvementCost:
  //       (taxInformationData && taxInformationData.improvementCost) || 0,
  //     installationCost:
  //       (taxInformationData && taxInformationData.installationCost) || 0,
  //     careExpenses:
  //       (taxInformationData && taxInformationData.careExpenses) || 0,
  //     numDependents:
  //       (taxInformationData && taxInformationData.numDependents) || 0,
  //     adoptionExpenses:
  //       (taxInformationData && taxInformationData.adoptionExpenses) || 0,
  //     educationExpensesAOTC:
  //       (taxInformationData && taxInformationData.educationExpensesAOTC) || 0,
  //     educationExpensesLLC:
  //       (taxInformationData && taxInformationData.educationExpensesLLC) || 0,
  //     purchasePrice:
  //       (taxInformationData && taxInformationData.vehiclePurchasePrice) || 0,
  //     vehicleType:
  //       (taxInformationData && taxInformationData.vehicleType) || null, // 'new' or 'used'
  //     numChildren: (taxInformationData && taxInformationData.numChildren) || 0,
  //     earnedIncome:
  //       (taxInformationData && taxInformationData.earnedIncome) ||
  //       (taxInformationData && taxInformationData.AGI) ||
  //       grossIncome,
  //     investmentIncome:
  //       (taxInformationData && taxInformationData.investmentIncome) || 0,
  //     foreignTaxPaid:
  //       (taxInformationData && taxInformationData.foreignTaxPaid) || 0,
  //   };

  //   // Calculate current year tax
  //   const results = calculateTotalTax(
  //     grossIncome,
  //     filingStatus,
  //     stateName,
  //     credits
  //   );

  //   // Calculate 10-year projection
  //   const projectionResult = calculateProjectionSeries({
  //     grossIncome,
  //     filingStatus,
  //     stateName,
  //     credits,
  //     generalInflationRate:
  //       generalInflationRate && !isNaN(generalInflationRate)
  //         ? Number(generalInflationRate)
  //         : 0.03,
  //     years: 10,
  //   });

  //   setResult({ ...projectionResult, ...results }); // Combine projections and current year results
  // }, [taxInformationData, yearlyDataReport, data]);

  useEffect(() => {
    if (!taxInformationData && !yearlyDataReport) return;

    // === 1. Core Inputs ===
    const grossIncome = yearlyDataReport
      ? yearlyDataReport.totalYearly
      : (taxInformationData && taxInformationData["Gross Income"]) || 0;

    const filingStatus =
      (taxInformationData && taxInformationData["Tax Filling Election"]) ||
      "single";
    const stateName =
      (taxInformationData && taxInformationData["State Taxation"]) ||
      "California";
    const city =
      (taxInformationData && taxInformationData["City of Residence"]) ||
      "Other";

    const deductionType =
      (
        (taxInformationData && taxInformationData["Deductions"]) ||
        "Standard"
      ).toLowerCase() === "itemized"
        ? "itemized"
        : "standard";

    const generalInflationRate =
      taxInformationData && taxInformationData.generalInflationRate
        ? Number(taxInformationData.generalInflationRate) / 100
        : 0.03;

    // === 2. Above-the-Line Deductions ===
    const hsa =
      (taxInformationData &&
        taxInformationData.hsaContributions &&
        parseFloat(taxInformationData.hsaContributions)) ||
      0;
    const studentLoan =
      (taxInformationData &&
        taxInformationData.studentLoan &&
        parseFloat(taxInformationData.studentLoan)) ||
      0;
    const tradIra =
      (taxInformationData &&
        taxInformationData.iraContribution &&
        parseFloat(taxInformationData.iraContribution)) ||
      0;
    const educator =
      (taxInformationData &&
        taxInformationData.educatorExpenses &&
        parseFloat(taxInformationData.educatorExpenses)) ||
      0;

    const netShortTerm =
      (taxInformationData &&
        taxInformationData.shortTermGainsLoss &&
        parseFloat(taxInformationData.shortTermGainsLoss)) ||
      0;
    const netLongTerm =
      (taxInformationData &&
        taxInformationData.longTermGainsLoss &&
        parseFloat(taxInformationData.longTermGainsLoss)) ||
      0;
    const carryforward =
      (taxInformationData &&
        taxInformationData.lossCarryforward &&
        parseFloat(taxInformationData.lossCarryforward)) ||
      0;

    // === 3. Capital Gains & Losses (from carryForwardCredits) ===
    let shortTermGains = 0,
      shortTermLosses = 0,
      longTermGains = 0,
      longTermLosses = 0,
      carryforwardLoss =
        (taxInformationData &&
          taxInformationData.lossCarryforward &&
          parseFloat(taxInformationData.lossCarryforward)) ||
        0;

    carryForwardCredits &&
      carryForwardCredits.forEach((asset) => {
        if (!asset.enable || asset.deleted) return;

        const purchasePrice = parseFloat(asset.purchasePrice) || 0;
        const salePrice = parseFloat(asset.salePrice) || 0;
        const commission = parseFloat(asset.commissionAndFees) || 0;
        const purchaseDate = new Date(asset.purchaseDate);
        const saleDate = new Date(asset.saleDate);
        const holdingYears =
          (saleDate - purchaseDate) / (1000 * 60 * 60 * 24 * 365);
        const gainLoss = salePrice - purchasePrice - commission;

        if (gainLoss >= 0) {
          if (holdingYears > 1) longTermGains += gainLoss;
          else shortTermGains += gainLoss;
        } else {
          if (holdingYears > 1) longTermLosses += Math.abs(gainLoss);
          else shortTermLosses += Math.abs(gainLoss);
        }
      });

    // === 4. Itemized Deductions ===
    const itemized =
      deductionType === "itemized"
        ? {
            medical:
              (taxInformationData &&
                parseFloat(
                  taxInformationData["Medical and Dental Expenses"]
                )) ||
              0,
            salt:
              (taxInformationData &&
                parseFloat(
                  taxInformationData["State and Local Taxes (SALT)"]
                )) ||
              0,
            mortgage:
              (taxInformationData &&
                parseFloat(taxInformationData["Home Mortgage Interest"])) ||
              0,
            charity:
              (taxInformationData &&
                parseFloat(taxInformationData["Charitable Contributions"])) ||
              0,
          }
        : {};

    // === 5. Credits Mapping (from creditData) ===
    let careExpenses = 0;
    let educationExpenses = 0;
    let numDependents =
      (taxInformationData && taxInformationData["Number of Dependents"]) || 0;
    const credits = {
      numChildrenUnder17: 0,
      contributionAmount:
        (taxInformationData && taxInformationData.iraContribution) || 0,
      agi: (taxInformationData && taxInformationData.AGI) || grossIncome,
      magi:
        (taxInformationData && taxInformationData.MAGI) ||
        (taxInformationData && taxInformationData.AGI) ||
        grossIncome,
      improvementCost: 0,
      installationCost: 0,
      careExpenses: 0,
      numDependents: numDependents,
      adoptionExpenses: 0,
      educationExpensesAOTC: 0,
      educationExpensesLLC: 0,
      purchasePrice: 0,
      vehicleType: null,
      numChildren: 0,
      earnedIncome:
        (taxInformationData && taxInformationData.earnedIncome) ||
        (taxInformationData && taxInformationData.AGI) ||
        grossIncome,
      investmentIncome:
        (taxInformationData && taxInformationData.investmentIncome) || 0,
      foreignTaxPaid: 0,
      premiumTaxCredit: 0, // New field for Premium Tax Credit
      otherCredits: 0, // New field for Other credits
    };

    creditData &&
      creditData.forEach((credit) => {
        if (!credit.enable || credit.deleted) return;
        const amount = parseFloat(credit.amountOfCredit) || 0;
        switch (credit.taxCredit) {
          case "Child & Dependent Care Credit":
            careExpenses += Math.max(careExpenses, amount / 0.2); // Reverse from 20% min rate
            // numDependents += Math.max(numDependents, amount >= 6000 ? 2 : 1);
            credit.careExpenses += Math.max(careExpenses, amount / 0.2); // Reverse from 20% min rate
            // credit.numDependents += Math.max(
            //   numDependents,
            //   amount >= 6000 ? 2 : 1
            // );
            break;
          case "American Opportunity Credit":
          case "Lifetime Learning Credit":
            educationExpenses += amount; // Sum both
            credit.educationExpenses += amount; // Sum both
            break;
          case "Adoption Credit":
            credits.adoptionExpenses = Math.min(amount, 17280); // Cap at 2025 max
            break;
          case "Earned Income Tax Credit (EITC)":
            credits.numChildren = Math.max(credits.numChildren, 1); // Assume at least 1 child
            break;
          case "American Opportunity Credit":
            credits.educationExpensesAOTC = Math.min(amount / 0.4, 4000); // Reverse calculate, cap at $4000
            break;
          case "Lifetime Learning Credit":
            credits.educationExpensesLLC = Math.min(amount / 0.2, 10000); // Reverse calculate, cap at $10000
            break;
          case "Saver's Credit":
            credits.contributionAmount = Math.min(amount / 0.5, 4000); // Assume max 50% rate, cap at $4000
            break;
          case "Premium Tax Credit":
            credits.premiumTaxCredit += amount; // Direct addition as refundable credit
            break;
          case "Clean Vehicle Credit":
            credits.purchasePrice = amount;
            credits.vehicleType = amount > 4000 ? "new" : "used";
            break;
          case "Energy Efficient Home Improvement Credit":
            credits.improvementCost = Math.min(amount / 0.3, 1200 / 0.3); // Reverse calculate, cap at $1200
            break;
          case "Residential Clean Energy Credit":
            credits.installationCost = amount / 0.3; // Reverse calculate, no cap
            break;
          case "Foreign Tax Credit":
            credits.foreignTaxPaid += amount;
            break;
          case "Other":
            credits.otherCredits += amount; // Treat as non-refundable for simplicity
            break;
          // Add other credits if needed (EITC, Saver's, etc. handled internally)
          default:
            break;
        }
      });

    const dependents =
      (taxInformationData &&
        taxInformationData["Number of Dependents"] &&
        parseInt(taxInformationData["Number of Dependents"])) ||
      numDependents;
    // === 6. Final Input Object for calculateTotalTax ===
    const taxInputs = {
      w2Income: grossIncome,
      seNetIncome: 0, // Add if you have self-employment
      filingStatus,
      state: stateName,
      city,
      hsa,
      studentLoanInterest: studentLoan,
      iraContributions: tradIra,
      sepSimpleContributions: 0,
      educatorExpenses: educator,
      childCareExpenses: careExpenses,
      qualifiedEducationExpenses: educationExpenses,
      dependents,
      deductionType,
      itemized,
      // Capital Gains (net values passed directly)
      netShortTermCG: netShortTerm,
      netLongTermCG: netLongTerm,
      carryforward: carryforward, // Negative = loss
    };

    // === 7. Calculate Current Year Tax ===
    const currentYearResult = calculateTotalTax(taxInputs);

    // === 8. Capital Gains Tax (already included in main calc, but optional separate) ===
    // If you want separate breakdown:
    const cgResult = calculateCapitalGainsTax({
      shortTermGains,
      shortTermLosses,
      longTermGains,
      longTermLosses,
      carryforwardLoss: carryforwardLoss * -1,
      ordinaryIncome: grossIncome,
      filingStatus,
      stateName,
    });

    // === 9. 10-Year Projection ===
    const projectionResult = calculateProjectionSeries({
      ...taxInputs,
      inflation: generalInflationRate,
      years: 10,
    });
    // console.log("currentYearResult", currentYearResult);
    // === 10. Combine & Set Result ===
    setResult({
      // Current Year
      ...currentYearResult,
      grossIncome: Math.round(grossIncome),
      effectiveRate: currentYearResult.effectiveRate,
      marginalRate: currentYearResult.marginalRate,

      // Capital Gains Breakdown
      capitalGains: {
        netSTCG: shortTermGains - shortTermLosses,
        netLTCG: longTermGains - longTermLosses,
        carryforwardLoss: carryforwardLoss,
        capitalGainsTax: cgResult.capitalGainsTax,
        deductibleLoss: cgResult.deductibleLoss,
      },
      shortTermGainsLoss: shortTermGains - shortTermLosses,
      longTermGainsLoss: longTermGains - longTermLosses,
      numDependents,
      // Projection
      ...projectionResult,
    });
  }, [taxInformationData, yearlyDataReport, creditData, carryForwardCredits]);

  // console.log("result==>", result,);

  const fields = [
    {
      Component: DropDownTax,
      value: {
        name: "State Taxation",
        title: "State Taxation",
        setSelectedItem: handleTaxInformation,
        list: statesList,
        displayKey: "name",
        value: taxInformationData && taxInformationData["State Taxation"],
        tooltip: "Tax_State_Taxation",
      },
    },
    {
      Component: DropDownTax,
      value: {
        name: "City of Residence",
        title: "City of Residence",
        setSelectedItem: handleTaxInformation,
        list: cityList,
        displayKey: "name",
        value: taxInformationData && taxInformationData["City of Residence"],
        tooltip: "Tax_State_Taxation",
      },
    },
    {
      Component: DropDownTax,
      value: {
        name: "Tax Filling Election",
        title: "Tax Filling Election",
        list: taxFillingElectionList,
        displayKey: "name",
        setSelectedItem: handleTaxInformation,
        value: taxInformationData && taxInformationData["Tax Filling Election"],
        tooltip: "Tax_Tax_Filing_Election",
      },
    },
    {
      Component: DropDownTax,
      value: {
        name: "Deductions",
        title: "Deductions",
        setSelectedItem: handleTaxInformation,
        list: deductionsList,
        displayKey: "name",
        value: taxInformationData && taxInformationData["Deductions"],
        tooltip: "Tax_Deductions",
      },
    },

    {
      Component: IconInputTax,
      value: {
        name: "Effective Tax Rate",
        title: "Effective Tax Rate",
        icon: "%",
        iconPosition: "end",
        value: result && result.effectiveRate ? result.effectiveRate : 0,
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "Tax_Total_Tax_Rate",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Marginal Tax Rate",
        title: "Marginal Tax Rate",
        icon: "%",
        iconPosition: "end",
        value: result && result.marginalRate ? result.marginalRate : 0,
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "Tax_Federal_Tax_Rate",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Total Tax Liability",
        title: "Total Tax Liability",
        icon: "$",
        iconPosition: "start",
        value:
          result && result.totalTaxLiability ? result.totalTaxLiability : 0,
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "Tax_Total_Tax_Liability",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Number of Dependents",
        title: "Number of Dependents",
        // icon: "$",
        // iconPosition: "start",
        value: taxInformationData && taxInformationData["Number of Dependents"],
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "Number_of_Dependents",
      },
    },
  ];
  const itemizedFields = [
    {
      Component: IconInputTax,
      value: {
        name: "Medical and Dental Expenses",
        title: "Medical and Dental Expenses",
        onChange: (event) => handleTaxInformation(event.target),
        icon: "$",
        iconPosition: "start",
        value:
          taxInformationData &&
          taxInformationData["Medical and Dental Expenses"],
        tooltip: "Medical and Dental Expenses",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "State and Local Taxes (SALT)",
        title: "State and Local Taxes (SALT)",
        onChange: (event) => handleTaxInformation(event.target),
        icon: "$",
        iconPosition: "start",
        value:
          taxInformationData &&
          taxInformationData["State and Local Taxes (SALT)"],
        tooltip: "State and Local Taxes (SALT)",
      },
    },

    {
      Component: IconInputTax,
      value: {
        name: "Home Mortgage Interest",
        title: "Home Mortgage Interest",
        icon: "$",
        iconPosition: "start",
        value:
          taxInformationData && taxInformationData["Home Mortgage Interest"],
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "Home Mortgage Interest",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Charitable Contributions",
        title: "Charitable Contributions",
        icon: "$",
        iconPosition: "start",
        value:
          taxInformationData && taxInformationData["Charitable Contributions"],
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "Charitable Contributions",
      },
    },
  ];
  const formFields = [
    {
      label: "Total Estimated Annual Gross Income",
      type: "number",
      name: "totalYearly",
    },
  ];
  const formFieldsIncomeAGIAdjustments = [
    {
      label: "W2 Gross Income",
      type: "number",
      name: "grossIncome",
    },
    {
      label: "Self-Employment Net Earnings",
      type: "number",
      name: "earnedIncome",
    },
    {
      label: "HSA Contributions",
      type: "number",
      name: "hsaContributions",
    },
    {
      label: "Student Loan Interest",
      type: "number",
      name: "studentLoan",
    },
    {
      label: "Traditional IRA Contribution",
      type: "number",
      name: "iraContribution",
    },
    {
      label: "Educator Expenses",
      type: "number",
      name: "educatorExpenses",
    },
  ];
  const formFieldsCapitalGainsLosses = [
    {
      label: "Net Short-Term Gains / (Loss)",
      type: "number",
      name: "shortTermGainsLoss",
    },
    {
      label: "Net Long-Term Gains / (Loss)",
      type: "number",
      name: "longTermGainsLoss",
    },
    {
      label: "Capital Loss Carryforward",
      type: "number",
      name: "lossCarryforward",
    },
  ];
  const formFieldsFederalTaxCredits = [
    {
      label: "Child & Dependent Care Expenses",
      type: "number",
      name: "careExpenses",
    },
    {
      label: "Qualified Education Expenses",
      type: "number",
      name: "educationExpenses",
    },
  ];

  return (
    <Style.MainContainer
      style={{
        backgroundColor: "#ffffff",
        margin: "16px",
        position: "relative",
      }}
    >
      <h2
        style={{
          fontSize: "28px",
          fontWeight: "600",
          color: "#2A3DA3",
          margin: "0",
        }}
      >
        Tax Information
      </h2>

      <Style.FieldsContainer>
        {fields &&
          fields.map((data, index) => {
            const { value, Component } = data;
            return (
              <InputGroup key={index} style={{ width: "30%" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {value.title === "numDependents"
                      ? "Number of Dependents"
                      : value.title}
                  </Text>
                  <ToolTipCreator name={value.tooltip} />
                </div>
                <Component key={index} value={value} />
              </InputGroup>
            );
          })}
      </Style.FieldsContainer>
      <div style={{ width: "90%", marginTop: "1rem" }}>
        {taxInformationData &&
          taxInformationData["Deductions"] &&
          taxInformationData["Deductions"] === "Itemized" && (
            <Text
              style={{
                textWrap: "nowrap",
                fontWeight: "500",
                textAlign: "left",
                fontSize: "18px",
              }}
            >
              Itemized Deductions
            </Text>
          )}
      </div>
      <Style.FieldsContainer>
        {taxInformationData &&
          taxInformationData["Deductions"] &&
          taxInformationData["Deductions"] === "Itemized" &&
          itemizedFields &&
          itemizedFields.map((data, index) => {
            const { value, Component } = data;
            return (
              <InputGroup key={index} style={{ width: "30%" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {value.title}
                  </Text>
                  <ToolTipCreator name={value.tooltip} />
                </div>
                <Component key={index} value={value} />
              </InputGroup>
            );
          })}
      </Style.FieldsContainer>
      <div style={{ width: "90%" }}>
        <Collapse
          defaultActiveKey={["Income & AGI Adjustments"]}
          className="custom-collapse"
        >
          <Panel
            header="Income & AGI Adjustments"
            key="Income & AGI Adjustments"
          >
            <SocialSecurityHardCodeFields
              formFields={
                formFieldsIncomeAGIAdjustments && formFieldsIncomeAGIAdjustments
              }
              formData={
                taxInformationData && {
                  ...taxInformationData,
                  grossIncome: result ? result.grossIncome : 0,
                }
              }
              onChange={handleTaxInformationChange}
            />
          </Panel>
        </Collapse>
      </div>
      <div style={{ width: "90%", marginTop: "1rem" }}>
        <Collapse
          defaultActiveKey={["Capital Gains & Losses"]}
          className="custom-collapse"
        >
          <Panel header="Capital Gains & Losses" key="Capital Gains & Losses">
            <SocialSecurityHardCodeFields
              formFields={
                formFieldsCapitalGainsLosses && formFieldsCapitalGainsLosses
              }
              formData={
                taxInformationData && {
                  ...taxInformationData,
                  // shortTermGainsLoss: result ? result.shortTermGainsLoss : 0,
                  // longTermGainsLoss: result ? result.longTermGainsLoss : 0,
                }
              }
              onChange={handleTaxInformationChange}
            />
          </Panel>
        </Collapse>
      </div>
      <div style={{ width: "90%", marginTop: "1rem" }}>
        <Collapse
          defaultActiveKey={["Federal Tax Credits"]}
          className="custom-collapse"
        >
          <Panel header="Federal Tax Credits" key="Federal Tax Credits">
            <SocialSecurityHardCodeFields
              formFields={
                formFieldsFederalTaxCredits && formFieldsFederalTaxCredits
              }
              formData={taxInformationData && taxInformationData}
              onChange={handleTaxInformationChange}
            />
          </Panel>
        </Collapse>
      </div>
      <div style={{ width: "90%" }}>
        <SocialSecurityHardCodeFields
          formFields={formFields && formFields}
          formData={yearlyDataReport && yearlyDataReport}
          onChange={handleInputChangeTax}
        />
        <Button
          style={{ marginTop: "8px" }}
          onClick={() => {
            if (yearlyDataReport) {
              const yearlyData = yearlyDataReport;
              let yearlyResponse = {
                ...yearlyDataReport,
                totalYearly: yearlyData
                  ? (+yearlyData.Active || 0) + (+yearlyData.Passive || 0)
                  : 0,
              };
              setYearlyDataReport(yearlyResponse);
            }
          }}
        >
          {" "}
          Reset
        </Button>
      </div>
      <NewLoader isLoading={loading} />
      <TaxProjectionOverview data={result && result} />
      <Style.ButtonContainer>
        <Button onClick={submitData}>Next</Button>
      </Style.ButtonContainer>
    </Style.MainContainer>
  );
}

export default TaxInformation;
